// Minimal client-side SEO helper for the SPA. Google renders JS, so this
// updates the document title and meta description per page.
export function setSeo({ title, description }) {
  if (typeof document === "undefined") return;
  if (title) document.title = title;
  if (description) {
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", description);
  }
}
